import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function PackageList({ registerTrademarkList, isV3 }) {
  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0),
    paddingLeft: '10px',
    paddingRight: '5px',
    textAlign: 'left',
    color: theme.palette.text.secondary,
    border: '0px',
    boxShadow: 'none',
    fontFamily: 'MontserratRegular',
    paddingTop: '0px',
  }));
  const ItemCenter = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '0px',
    boxShadow: 'none',
    fontFamily: 'MontserratRegular',
    paddingTop: '0px',
  }));
  const Header = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0),
    paddingLeft: '10px',
    textAlign: 'left',
    border: '0px',
    boxShadow: 'none',
    fontFamily: 'MontserratRegular',
    color: '#7B848D',
  }));
  const SubHeader = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(0),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: '0px',
    boxShadow: 'none',
    fontSize: '0.8rem',
    fontFamily: 'MontserratBold',
  }));
  const items = [
    {
      header: 'Review',
      text: 'Our specialists review every aspect of your application to find errors or inconsistencies.',
      basic: 1,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Prepare',
      text: 'Your application will be prepared for submission to the USPTO by trained professionals.',
      basic: 1,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Filing',
      text: 'Your mark will be submitted to the USPTO electronic filing system by our trained team.',
      basic: 1,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Email Delivery',
      text: 'Official updates of your USPTO status are delivered to your via E-mail.',
      basic: 1,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Trademark Monitoring',
      text: '1 Month of Free Trademark Monitoring included to ensure no infringements on your mark are filed.',
      basic: 1,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Cease & Desist Letter',
      text: 'In the event that you find an infringing mark, we will provide a Cease and Desist template for you to deliver to your infringing party.',
      basic: 0,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Advanced Search',
      text: 'A comprehensive search including federal and state directories is completed before your mark is filed to ensure there are no conflicts.',
      basic: 0,
      delux: 1,
      premier: 1,
    },
    {
      header: 'Transfer & Assignment',
      text: 'If you need to transfer your registered mark to another entity, we will complete this filing for you (Not including State fee).',
      basic: 0,
      delux: 0,
      premier: 1,
    },
    {
      header: 'Office Action Response',
      text: 'If the USPTO rejects your application, it will issue an Office Action. We will provide an included response to the action with our Premier service.',
      basic: 0,
      delux: 0,
      premier: 1,
    },
    {
      header: '100% Satisfaction Guaranteed',
      text: '',
      basic: 1,
      delux: 1,
      premier: 1,
    },
  ];
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid
        item
        xs={6}
        style={{
          borderTop: '1px solid #ECEDF1',
          borderBottom: '1px solid #ECEDF1',
          padding: '13px 0px',
        }}
      >
        <Header>Subscription</Header>
      </Grid>
      <Grid
        item
        xs={2}
        style={{
          borderTop: '1px solid #ECEDF1',
          borderBottom: '1px solid #ECEDF1',
          padding: '13px 0px',
        }}
      >
        <SubHeader style={{ color: '#7B848D' }}>Basic</SubHeader>
      </Grid>
      <Grid
        item
        xs={2}
        style={{
          borderTop: '1px solid #ECEDF1',
          borderBottom: '1px solid #ECEDF1',
          padding: '13px 0px',
        }}
      >
        <SubHeader style={{ color: '#F37217' }}>
          {isV3 ? 'Standard' : 'Deluxe'}
        </SubHeader>
      </Grid>
      <Grid
        item
        xs={2}
        style={{
          borderTop: '1px solid #ECEDF1',
          borderBottom: '1px solid #ECEDF1',
          padding: '13px 0px',
        }}
      >
        <SubHeader style={{ color: '#03589C' }}>Premier</SubHeader>
      </Grid>
      {items
        ? items.map((item, j) => (
            <Grid
              style={{
                borderBottom: '1px dashed #ECEDF1',
                padding: '10px 0px',
              }}
              container
              direction="row"
              key={j}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={6} style={{ borderRight: '1px solid #ECEDF1' }}>
                <Item>
                  <Typography
                    style={{
                      fontFamily: 'MontserratBold',
                      fontSize: '0.9em',
                      marginBottom: '6px',
                      color: '#7B848D',
                    }}
                  >
                    {item.header}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'MontserratRegular',
                      fontSize: '0.7em',
                      lineHeight: '12px',
                      color: '#7B848D',
                    }}
                  >
                    {item.text}
                  </Typography>
                </Item>
              </Grid>
              <Grid item xs={2}>
                <ItemCenter>
                  {item.basic === 1 ? (
                    <CheckCircleOutlineIcon style={{ color: '#7B848D' }} />
                  ) : (
                    <HorizontalRuleIcon style={{ color: '#A5AAAF' }} />
                  )}
                </ItemCenter>
              </Grid>
              <Grid item xs={2}>
                <ItemCenter>
                  {item.delux === 1 ? (
                    <CheckCircleOutlineIcon style={{ color: '#F37217' }} />
                  ) : (
                    <HorizontalRuleIcon style={{ color: '#A5AAAF' }} />
                  )}
                </ItemCenter>
              </Grid>
              <Grid item xs={2}>
                <ItemCenter>
                  {item.premier === 1 ? (
                    <CheckCircleOutlineIcon style={{ color: '#03589C' }} />
                  ) : (
                    <HorizontalRuleIcon style={{ color: '#A5AAAF' }} />
                  )}
                </ItemCenter>
              </Grid>
            </Grid>
          ))
        : null}
      {!isV3 && (
        <Grid
          style={{ borderBottom: '1px solid #ECEDF1', padding: '13px 0px' }}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={6}>
            <Item>
              <Typography
                style={{
                  fontFamily: 'MontserratBold',
                  fontSize: '0.9em',
                  marginBottom: '6px',
                  color: '#7B848D',
                }}
              >
                Price
              </Typography>
              <Typography
                style={{
                  fontFamily: 'MontserratRegular',
                  fontSize: '0.7em',
                  lineHeight: '12px',
                  color: '#A5AAAF',
                }}
              >
                + USPTO fees
              </Typography>
            </Item>
          </Grid>
          <Grid item xs={2}>
            <ItemCenter>
              <Typography
                style={{
                  fontFamily: 'MontserratBold',
                  fontSize: '0.9em',
                  lineHeight: '12px',
                  color: '#7B848D',
                }}
              >
                $
                {
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'BASIC'
                  )[0].price
                }
              </Typography>
            </ItemCenter>
          </Grid>
          <Grid item xs={2}>
            <ItemCenter>
              <Typography
                style={{
                  fontFamily: 'MontserratBold',
                  fontSize: '0.9em',
                  lineHeight: '12px',
                  color: '#F37217',
                }}
              >
                $
                {
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                  )[0].price
                }
              </Typography>
            </ItemCenter>
          </Grid>
          <Grid item xs={2}>
            <ItemCenter>
              <Typography
                style={{
                  fontFamily: 'MontserratBold',
                  fontSize: '0.9em',
                  lineHeight: '12px',
                  color: '#03589C',
                }}
              >
                $
                {
                  registerTrademarkList.filter(
                    (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                  )[0].price
                }
              </Typography>
            </ItemCenter>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
